"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "decreaseScreenShare", {
  enumerable: true,
  get: function get() {
    return _setScreenShare.decreaseScreenShare;
  }
});
Object.defineProperty(exports, "increaseScreenShare", {
  enumerable: true,
  get: function get() {
    return _setScreenShare.increaseScreenShare;
  }
});
Object.defineProperty(exports, "setScreenShare", {
  enumerable: true,
  get: function get() {
    return _setScreenShare.setScreenShare;
  }
});
var _setScreenShare = require("./setScreenShare");